import { LegacyThermostatType } from "../../../store/LegacyStore/models";

/**
 * Key for Enum lookup on the state
 */
export function getThermostatKey(thermostatType: LegacyThermostatType){
    return LegacyThermostatType[thermostatType] as keyof typeof LegacyThermostatType;
}